import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { ActivatedRoute, Router } from "@angular/router";

import { BaseComponent, CheckoutService, ContentService, environment, GAService, HelperService, ProductService, UserService, WindowService } from "@mypxplat/xplat/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { RegisterProductComponent, RegisterSuccessSplashComponent, SimpleSignupComponent, StudiooneGracePeriodComponent } from "../modals";
import { AppService, AvoService, FirebaseService } from "@mypxplat/xplat/web/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { filter, take } from "rxjs/operators";
import { Meta } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ProductPurchaseUpgradeComponent } from "../product-purchase-upgrade/product-purchase-upgrade.component";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-onboarding-options",
  templateUrl: "onboarding-options.component.html",
  standalone: false,
})
export class OnboardingOptionsComponent extends BaseComponent implements OnInit {
  public env = environment;
  public subscription: any;
  public couponParam: string;
  public upgradableProducts: any;
  public perpetualDisplayPrice: number;
  public isUpgrade: boolean = false;
  public alreadySubscribed: string;
  public subscribeOnly: boolean = false;
  public headerLogo: string;
  public activeCoupon: any;
  public currencyCode: string = "USD";
  public annualDisplayPrice: number = 179.99;
  public monthlyDisplayPrice: number = 19.99;
  public pricesLoaded: boolean = false;
  private priceList: any[] = [];
  private supportedCurrencies: string[] = [];
  constructor(
    public userService: UserService,
    private _spin: NgxSpinnerService,
    public win: WindowService,
    public translate: TranslateService,
    public gaService: GAService,
    public appService: AppService,
    public router: Router,
    public fbAuth: AngularFireAuth,
    public productService: ProductService,
    public helperService: HelperService,
    public activatedRoute: ActivatedRoute,
    public avoService: AvoService,
    public db: AngularFirestore,
    public metaService: Meta,
    private modalService: NgbModal,
    public fbService: FirebaseService,
    public checkoutService: CheckoutService,
    public contentService: ContentService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.appService.title = this.translate.instant("onboarding.signup_title");
    this.metaService.addTags([
      {
        name: "Description",
        content: this.translate.instant("onboarding.signup_description"),
      },
      { itemprop: "name", content: this.translate.instant("onboarding.signup_title") },
      {
        itemprop: "Description",
        content: this.translate.instant("onboarding.signup_description"),
      },
      {
        itemprop: "image",
        content: this.env.features.studio_one_seven
          ? "https://my.presonus.com/angular/assets/images/s17-images/s17-bundle-annual.png"
          : "https://my.presonus.com/angular/assets/images/presonus-sphere-bundle.png",
      },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:site", content: "@PreSonus" },
      { name: "twitter:title", content: this.translate.instant("onboarding.signup_title") },
      {
        name: "twitter:description",
        content: this.translate.instant("onboarding.signup_description"),
      },
      { name: "twitter:creator", content: "@PreSonus" },
      {
        name: "twitter:image:src",
        content: this.env.features.studio_one_seven
          ? "https://my.presonus.com/angular/assets/images/s17-images/s17-bundle-annual.png"
          : "https://my.presonus.com/angular/assets/images/presonus-sphere-bundle.png",
      },
      { property: "og:url", content: "https://my.presonus.com/signup" },
      { property: "og:title", content: this.translate.instant("onboarding.signup_title") },
      {
        property: "og:description",
        content: this.translate.instant("onboarding.signup_description"),
      },
      { property: "og:site_name", content: this.translate.instant("onboarding.signup_title") },
      {
        property: "og:image",
        content: this.env.features.studio_one_seven
          ? "https://my.presonus.com/angular/assets/images/s17-images/s17-bundle-annual.png"
          : "https://my.presonus.com/angular/assets/images/presonus-sphere-bundle.png",
      },
      { property: "fb:app_id", content: "243955558952702" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_US" },
      { name: "my.presonus", content: "my.presonus" },
      { name: "Presonus register", content: "Presonus register" },
      { name: "Presonus product registration", content: "Presonus product registration" },
      { name: "Mypresonus", content: "Mypresonus" },
      { name: "My presonus", content: "My presonus" },
      { name: "Mypresonus login", content: "Mypresonus login" },
      { name: "My presonus login", content: "My presonus login" },
      { name: "my.presonus login", content: "my.presonus login" },
      { name: "Studio one login", content: "Studio one login" },
      { name: "Studio One Pro+ login", content: "Studio One Pro+ login" },
      { name: "Presonus login", content: "Presonus login" },
      { name: "Log into my presonus", content: "Log into my presonus" },
      { name: "Log into mypresonus", content: "Log into mypresonus" },
      { name: "Studio one free demo", content: "Studio one free demo" },
      { name: "Studio one free", content: "Studio one free" },
      { name: "Studio one demo", content: "Studio one demo" },
      { name: "Studio one prime", content: "Studio one prime" },
    ]);
    if (this.activatedRoute.snapshot.queryParamMap.get("subscribeOnly")) this.subscribeOnly = true;
    if (this.activatedRoute.snapshot.queryParamMap.get("registerProduct")) {
      this.showRegisterProduct();
    }
    // this.appService.initTheme("auto");
    this.headerLogo = this.subscribeOnly ? this.appService.s1proPlusLogo : this.appService.s1pro7Logo;

    // check query params for term
    if (this.activatedRoute.snapshot.queryParams.term) {
      this._spin.show();
      if (this.userService.user) {
        this.userService.getSubscriptionDetails(true).subscribe({
          next: (result) => {
            if (result.active && result.subscription) this.alreadySubscribed = result.subscription.subscription_levels_id == 1 ? "monthly" : "annual";
            this.continueSphere(this.activatedRoute.snapshot.queryParams.term);
          },
        });
      }
    } else {
      if (this.userService.user) {
        this.userService.getSubscriptionDetails(true).subscribe({
          next: (result) => {
            if (result.active && result.subscription) {
              this.alreadySubscribed = result.subscription.subscription_levels_id == 1 ? "monthly" : "annual";
            }
          },
        });
        this.checkoutService.getUpgradableProducts().subscribe((result) => {
          this.perpetualDisplayPrice = result.data.prices.find((price) => price.currency === "usd").unit_amount / 100;
          this.userService.getActiveOffers().subscribe((activeOffersResult: any) => {
            if (activeOffersResult && activeOffersResult.length) {
              activeOffersResult.forEach((coupon) => {
                let appliesToProducts = coupon.applies_to_products.split(",").map((product) => product.trim());
                if (appliesToProducts.includes(this.checkoutService.upgradableStudioOneProducts?.data?.products[0].stripeProductId)) this.activeCoupon = coupon;
              });
            }
            let amountOff = Math.floor(this.perpetualDisplayPrice * this.activeCoupon?.percentage) / 100;
            if (this.activeCoupon) this.perpetualDisplayPrice = parseFloat((this.perpetualDisplayPrice - amountOff).toFixed(2));
            this.upgradableProducts = result.data;
            this.isUpgrade = this.upgradableProducts.products[0].title.indexOf("Upgrade") > -1;
            this.loadLocalizedPrices();
          });
        });
      } else {
        this.loadLocalizedPrices();
      }
    }
  }

  public redeeming: boolean = false;
  goToCheckout(queryParam?) {
    if (!this.userService.user) {
      this.appService.promptSimpleSignup(SimpleSignupComponent);
      return;
    }
    if (queryParam == "Perpetual" && this.productService.studioOneStatus?.status == "can_redeem_fsp8") {
      const modalRef = this.appService.showModal(StudiooneGracePeriodComponent, {
        size: "lg",
        container: this.appService.appContainer,
      });
    } else {
      let url = "/checkout";
      if (queryParam) url += "?checkoutProductType=" + queryParam;
      this.appService.goToCheckout(url);
    }
  }

  showRegisterProduct() {
    if (!this.userService.user) {
      this.appService.promptSimpleSignup(SimpleSignupComponent);
      return;
    }
    if (this.userService.appId === "fender") {
      this.avoService.avoInitted$
        .pipe(
          filter((v) => !!v),
          take(1)
        )
        .subscribe(() => {
          const te = this.avoService.trackEvent();
          if (te && typeof (te as any).ctaClicked === "function") {
            const page = this.avoService.getPageProperties({ pageName: "Onboarding" });
            const extra: Record<string, any> = {
              ctaText: "Register here",
              ctaLocation: "Onboarding",
              utmId: (page as any).utmId ?? 0,
              utmTerm: (page as any).utmTerm ?? "",
            };
            const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
            (te as any).ctaClicked(payload);
          }
        });
    }
    this.appService.closeModals();
    const modalRef = this.appService.showModal(RegisterProductComponent, {
      size: "lg",
      ariaLabelledBy: "modal-title",
      beforeDismiss: () => {
        if (modalRef.componentInstance.registering) {
          alert(this.translate.instant("products.register.registration_in_process"));
          return false;
        }
      },
    });
    modalRef.componentInstance.autoNavigate = true;
  }

  continueFree() {
    if (!this.userService.user) {
      this.appService.promptSimpleSignup(SimpleSignupComponent);
      return;
    }
    if (this.userService.appId === "fender") {
      this.avoService.avoInitted$
        .pipe(
          filter((v) => !!v),
          take(1)
        )
        .subscribe(() => {
          const te = this.avoService.trackEvent();
          if (te && typeof (te as any).ctaClicked === "function") {
            const page = this.avoService.getPageProperties({ pageName: "Onboarding" });
            const extra: Record<string, any> = {
              ctaText: "Return to My Fender",
              ctaLocation: "Onboarding",
              utmId: (page as any).utmId ?? 0,
              utmTerm: (page as any).utmTerm ?? "",
            };
            const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
            (te as any).ctaClicked(payload);
          }
        });
    }
    this.appService.closeModals();
    this.appService.initApp();
    this.router.navigate(["/home"]);
  }

  loadLocalizedPrices() {
    const countryCode = this.userService.user?.country;
    if (!countryCode || countryCode.toUpperCase() === "US") {
      this.pricesLoaded = true;
      return;
    }

    // Fetch all Stripe prices to get price IDs and check for existing currency prices
    this.userService.getSpherePricesStripe().subscribe({
      next: (result: any) => {
        if (result?.prices) {
          // Combine subscription prices with perpetual prices from upgradableProducts
          this.priceList = result.prices || [];
          if (this.upgradableProducts?.prices) {
            this.priceList = [...this.priceList, ...this.upgradableProducts.prices];
          }
          this.supportedCurrencies = result.supported_currencies || [];
          this.loadPriceByCountry(countryCode);
        } else {
          this.pricesLoaded = true;
        }
      },
      error: () => {
        this.pricesLoaded = true;
      },
    });
  }

  loadPriceByCountry(countryCode: string) {
    this.userService.getCurrencyCodeByCountryCode(countryCode).subscribe({
      next: (result: any) => {
        if (result?.data?.locations?.[0]?.["currency-code"]) {
          const targetCurrency = result.data.locations[0]["currency-code"];
          if (targetCurrency.toUpperCase() === "USD") {
            this.pricesLoaded = true;
            return;
          }
          this.currencyCode = targetCurrency;

          // Check if we have Stripe prices for this currency
          const filteredPrices = this.priceList.filter((p) => p.currency.toLowerCase() === targetCurrency.toLowerCase());

          if (filteredPrices && filteredPrices.length) {
            // Use existing Stripe prices for this currency
            this.setPricesFromStripe(filteredPrices, targetCurrency);
          } else if (this.supportedCurrencies.includes(targetCurrency.toLowerCase())) {
            // Currency is supported but no Stripe prices - convert from USD
            this.convertPricesToLocalCurrency(targetCurrency);
          } else {
            // Currency not supported - fall back to USD
            this.currencyCode = "USD";
            this.pricesLoaded = true;
          }
        } else {
          this.pricesLoaded = true;
        }
      },
      error: () => {
        this.pricesLoaded = true;
      },
    });
  }

  setPricesFromStripe(prices: any[], currency: string) {
    const isNoDecimal = environment.stripe.no_decimal_currencies?.includes(currency.toUpperCase());
    prices.forEach((price) => {
      const amount = isNoDecimal ? price.unit_amount : price.unit_amount / 100;
      if (price.recurring?.interval === "year") {
        this.annualDisplayPrice = amount;
      } else if (price.recurring?.interval === "month") {
        this.monthlyDisplayPrice = amount;
      } else if (!price.recurring && this.upgradableProducts) {
        // One-time price for perpetual - match by product ID
        const perpetualProduct = this.upgradableProducts.products?.[0];
        if (perpetualProduct && price.product === perpetualProduct.stripeProductId) {
          this.perpetualDisplayPrice = amount;
        }
      }
    });
    this.pricesLoaded = true;
  }

  convertPricesToLocalCurrency(targetCurrency: string) {
    // Get USD base prices from the price list
    const basePrices = this.priceList.filter((p) => p.currency === "usd");
    const currencyData: any = {
      currency_code: targetCurrency,
      convert: [],
    };

    basePrices.forEach((price) => {
      const value = (price.unit_amount / 100).toFixed(2);
      if (price.recurring?.interval) {
        currencyData.convert.push({
          from: "usd",
          priceId: price.id,
          value: value,
          interval: price.recurring.interval,
        });
      } else {
        // One-time price (perpetual)
        currencyData.convert.push({
          from: "usd",
          priceId: price.id,
          value: value,
          product: price.product,
        });
      }
    });

    if (!currencyData.convert.length) {
      this.pricesLoaded = true;
      return;
    }

    this.userService.currencyConvert(currencyData).subscribe({
      next: (result: any) => {
        if (result?.success && result?.data) {
          const isNoDecimal = environment.stripe.no_decimal_currencies?.includes(targetCurrency.toUpperCase());
          result.data.forEach((price: any) => {
            if (price.valid) {
              const convertedPrice = isNoDecimal ? Math.round(price["result-float"]) : Number(price["result-float"].toFixed(2));
              if (price.interval === "year") {
                this.annualDisplayPrice = convertedPrice;
              } else if (price.interval === "month") {
                this.monthlyDisplayPrice = convertedPrice;
              } else if (price.product && this.upgradableProducts) {
                // Match perpetual by product ID
                const perpetualProduct = this.upgradableProducts.products?.[0];
                if (perpetualProduct && price.product === perpetualProduct.stripeProductId) {
                  this.perpetualDisplayPrice = convertedPrice;
                }
              }
            }
          });
        }
        this.pricesLoaded = true;
      },
      error: () => {
        this.pricesLoaded = true;
      },
    });
  }

  continueSphere(term) {
    if (!this.userService.user) {
      this.appService.promptSimpleSignup(SimpleSignupComponent);
      return;
    }
    this.appService.closeModals();
    if (this.alreadySubscribed) {
      this.router.navigate([`/account/plan`]);
    } else {
      this.appService.goToCheckout("/checkout?term=" + term, this.env.product_ids["sphere_" + term]);
    }
  }

  logout() {
    this.router.navigate(["/logout"]);
  }

  close() {
    this.modalService.dismissAll();
  }

  ngOnDestroy() {
    let body = document.getElementsByTagName("body")[0];
    body.classList.remove("sphere-color-bg");
    body.classList.remove("full-page");
    this.userService.isInWelcomeFlow = false;
  }
}
